import React, { useState, useEffect, useContext } from "react";
import Sidebar from "../../components/sidebar";
import TopBar from "../../components/topbar";
import { useNavigate } from 'react-router-dom'
import axios from "axios";
import DataTable from "react-data-table-component";
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import { TiDelete } from 'react-icons/ti'
import { decode as base64_decode, encode as base64_encode } from 'base-64';

import { GlobalContext } from "../../contexts/global";

import { Col, Row, Card, Form, Button, ButtonGroup, Breadcrumb, Modal, Tabs, Tab } from 'react-bootstrap'

import { formatToCNPJ, isCNPJ, formatToPhone } from 'brazilian-values'

function TelaPropostas() {

    const Navigate = useNavigate()

    const { conexao, loading, limpaCNPJ, setLoading } = useContext(GlobalContext)

    const [propostas, setPropostas] = useState([])
    const [itensPropostas, setItensPropostas] = useState([])

    const [propostaSelecionada, setPropostaSelecionada] = useState({})
    const [itemAtual, setItemAtual] = useState({})


    const [modalProposta, setModalProposta] = useState(false)
    const [modoEdicao, setModoEdicao] = useState(false)

    useEffect(() => {
        if (localStorage.getItem('email')) {
            GetPropostas()
        } else {
            Navigate('/')
        }

    }, [])

    function GetPropostas() {

        setLoading(true)
        setPropostas([])

        const url = conexao.endereco + '/propostas/listar'

        let requisicao = new XMLHttpRequest()

        requisicao.timeout = 10000
        requisicao.open("POST", url, true)
        requisicao.setRequestHeader("Content-Type", "application/json")
        requisicao.setRequestHeader("token", localStorage.getItem('Token'))
        requisicao.send()

        requisicao.ontimeout = function () {
            console.log('Deu TimeOut')
            setLoading(false)
        }

        requisicao.onerror = function () {
            console.log('Deu Erro: ' + this.responseText)
            setLoading(false)
        }

        requisicao.onload = function () {
            setLoading(false)
            if (requisicao.status === 200) {
                let resposta = JSON.parse(this.response)
                setPropostas(resposta)
            }
        }
    }

    function GetItensPropostas(proposta) {

        setLoading(true)

        const url = conexao.endereco + '/propostas/itens/listar'

        let body = {
            "proposta": proposta
        }

        let requisicao = new XMLHttpRequest()

        requisicao.timeout = 10000
        requisicao.open("POST", url, true)
        requisicao.setRequestHeader("Content-Type", "application/json")
        requisicao.setRequestHeader("token", localStorage.getItem('Token'))
        requisicao.send(JSON.stringify(body))

        requisicao.ontimeout = function () {
            console.log('Deu TimeOut')
            setLoading(false)
        }

        requisicao.onerror = function () {
            console.log('Deu Erro: ' + this.responseText)
            setLoading(false)
        }

        requisicao.onload = function () {
            setLoading(false)
            if (requisicao.status === 200) {
                let resposta = JSON.parse(this.response)
                setItensPropostas(resposta)
            } else {
                setItensPropostas([])
            }
        }
    }

    function AtualizarProposta() {

        setLoading(true)

        const url = conexao.endereco + '/propostas/atualizar'

        let body = {
            "proposta": propostaSelecionada.prop_id,
            "contato": propostaSelecionada.prop_contato,
            "plano": propostaSelecionada.prop_plano,
            "cliente": propostaSelecionada.prop_cliente,
            "email": propostaSelecionada.prop_email,
            "whatsapp": propostaSelecionada.prop_whatsapp,
            "status": propostaSelecionada.prop_status,
            "qtde_times": propostaSelecionada.prop_qtde_times,
            "qtde_membros": propostaSelecionada.prop_qtde_membros
        }

        let requisicao = new XMLHttpRequest()

        requisicao.timeout = 10000
        requisicao.open("POST", url, true)
        requisicao.setRequestHeader("Content-Type", "application/json")
        requisicao.setRequestHeader("token", localStorage.getItem('Token'))
        requisicao.send(JSON.stringify(body))

        requisicao.ontimeout = function () {
            console.log('Deu TimeOut')
            setLoading(false)
        }

        requisicao.onerror = function () {
            console.log('Deu Erro: ' + this.responseText)
            setLoading(false)
        }

        requisicao.onload = function () {
            if (requisicao.status === 200) {
                let resposta = JSON.parse(this.response)
                GetPropostas()
                setLoading(false)
            }
        }
    }

    function IncluirProposta() {

        setLoading(true)

        const url = conexao.endereco + '/propostas/incluir'

        let body = {
            "contato": propostaSelecionada.prop_contato,
            "cliente": propostaSelecionada.prop_cliente,
            "plano": propostaSelecionada.prop_plano,
            "email": propostaSelecionada.prop_email,
            "whatsapp": propostaSelecionada.prop_whatsapp,
            "status": propostaSelecionada.prop_status,
            "qtde_times": propostaSelecionada.prop_qtde_times,
            "qtde_membros": propostaSelecionada.prop_qtde_membros
        }

        let requisicao = new XMLHttpRequest()

        requisicao.timeout = 10000
        requisicao.open("POST", url, true)
        requisicao.setRequestHeader("Content-Type", "application/json")
        requisicao.setRequestHeader("token", localStorage.getItem('Token'))
        requisicao.send(JSON.stringify(body))

        requisicao.ontimeout = function () {
            console.log('Deu TimeOut')
            setLoading(false)
        }

        requisicao.onerror = function () {
            console.log('Deu Erro: ' + this.responseText)
            setLoading(false)
        }

        requisicao.onload = function () {
            if (requisicao.status === 201) {
                setModalProposta(false)
                let resposta = JSON.parse(this.response)
                GetPropostas()
                setLoading(false)
            }
        }
    }

    function IncluirItemProposta() {

        setLoading(true)

        const url = conexao.endereco + '/propostas/itens/incluir'

        let body = {
            "proposta": propostaSelecionada?.prop_id,
            "item": itemAtual.item,
            "desconto": itemAtual.desconto,
            "valor": itemAtual.valor,
            "periodicidade": itemAtual.item_periodicidade
        }

        let requisicao = new XMLHttpRequest()

        requisicao.timeout = 10000
        requisicao.open("POST", url, true)
        requisicao.setRequestHeader("Content-Type", "application/json")
        requisicao.setRequestHeader("token", localStorage.getItem('Token'))
        requisicao.send(JSON.stringify(body))

        requisicao.ontimeout = function () {
            console.log('Deu TimeOut')
            setLoading(false)
        }

        requisicao.onerror = function () {
            console.log('Deu Erro: ' + this.responseText)
            setLoading(false)
        }

        requisicao.onload = function () {
            if (requisicao.status === 201) {
                let resposta = JSON.parse(this.response)
                GetItensPropostas(propostaSelecionada?.prop_id)
                setItemAtual({ item: '', valor: '', desconto: '0' })
                setLoading(false)
            }
        }
    }

    function ExcluirProposta() {

        setLoading(true)

        const url = conexao.endereco + '/propostas/excluir'

        let body = {
            "proposta": propostaSelecionada.prop_id
        }

        let requisicao = new XMLHttpRequest()

        requisicao.timeout = 10000
        requisicao.open("POST", url, true)
        requisicao.setRequestHeader("Content-Type", "application/json")
        requisicao.setRequestHeader("token", localStorage.getItem('Token'))
        requisicao.send(JSON.stringify(body))

        requisicao.ontimeout = function () {
            console.log('Deu TimeOut')
            setLoading(false)
        }

        requisicao.onerror = function () {
            console.log('Deu Erro: ' + this.responseText)
            setLoading(false)
        }

        requisicao.onload = function () {
            if (requisicao.status === 200) {
                let resposta = JSON.parse(this.response)
                setModalProposta(false)
                GetPropostas()
                setLoading(false)
            }
        }
    }

    function ExcluirItemProposta(identificacao) {

        setLoading(true)

        const url = conexao.endereco + '/propostas/itens/excluir'

        let body = {
            "item": identificacao
        }

        let requisicao = new XMLHttpRequest()

        requisicao.timeout = 10000
        requisicao.open("POST", url, true)
        requisicao.setRequestHeader("Content-Type", "application/json")
        requisicao.setRequestHeader("token", localStorage.getItem('Token'))
        requisicao.send(JSON.stringify(body))

        requisicao.ontimeout = function () {
            console.log('Deu TimeOut')
            setLoading(false)
        }

        requisicao.onerror = function () {
            console.log('Deu Erro: ' + this.responseText)
            setLoading(false)
        }

        requisicao.onload = function () {
            if (requisicao.status === 200) {
                let resposta = JSON.parse(this.response)
                GetItensPropostas(propostaSelecionada?.prop_id)
                setLoading(false)
            }
        }
    }

    const paginationComponentOptions = {
        rowsPerPageText: 'Registros por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const colunas = [
        {
            name: 'Data',
            selector: row => row.data_formatada,
            cellExport: row => row.data_formatada,
            sortable: true,
            // minWidth: '120px',
            maxWidth: '120px',
        },
        {
            name: 'Cliente',
            selector: row => row.prop_cliente,
            cellExport: row => row.prop_cliente,
            sortable: true,
            // minWidth: '120px',
            // maxWidth: '120px',
        },
        {
            name: 'Contato',
            selector: row => row.prop_contato,
            cellExport: row => row.prop_contato,
            sortable: true,
            // minWidth: '200px',
        },
        {
            name: 'Plano',
            selector: row => row.prop_plano,
            cellExport: row => row.prop_plano,
            sortable: true,
            // minWidth: '200px',
        },
        {
            name: 'Status',
            selector: row => row.prop_status,
            cellExport: row => row.prop_status,
            sortable: true,
            // minWidth: '120px',
            maxWidth: '380px',
        }
    ];

    const colunasItens = [
        {
            name: 'Descrição do Item',
            selector: row => row.item_descricao,
            sortable: true,
            // minWidth: '120px',
            // maxWidth: '120px',
        },
        {
            name: 'Periodicidade',
            selector: row => row.item_periodicidade,
            sortable: true,
            maxWidth: '180px',
            right: 'true'
        },
        {
            name: 'Valor',
            selector: row => Number(row.item_valor),
            format: row => Number(row?.item_valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            sortable: true,
            maxWidth: '150px',
            right: 'true'
        },
        {
            name: 'Desconto',
            selector: row => Number(row.item_desconto),
            format: row => Number(row?.item_desconto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            sortable: true,
            maxWidth: '150px',
            right: 'true'
        },
        {
            name: 'Valor Final',
            selector: row => Number(row?.item_valor) - Number(row?.item_desconto),
            format: row => Number(Number(row?.item_valor) - Number(row?.item_desconto)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            sortable: true,
            maxWidth: '150px',
            right: 'true'
        },
        {
            name: '',
            button: true,
            cell: row => (
                < a onClick={() => { ExcluirItemProposta(row.item_id) }} >
                    <TiDelete size="24" color="#d9534f" title="Excluir Condição" />
                </a>
            ),
        },
    ];

    const tableData = {
        columns: colunas,
        data: propostas,
        filterPlaceholder: 'Filtrar',
        exportHeaders: true
    };

    return (
        <>

            <div className='principal'>
                <Sidebar />
                <div className="principal-content">
                    <TopBar />
                    <div className="conteudo">
                        <Row>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Propostas Comerciais</Breadcrumb.Item>
                            </Breadcrumb>
                        </Row>
                        <Row>
                            <Col lg={6} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <ButtonGroup size="sm" style={{ marginBottom: 15 }}>
                                    <Button variant="light" style={{ minWidth: 120, backgroundColor: '#436996', color: 'white', marginRight: 0 }} onClick={() => {
                                        setModoEdicao(false)
                                        setPropostaSelecionada({})
                                        setItemAtual({ item: '', valor: '', desconto: '0' })
                                        setModalProposta(true)
                                    }}>Incluir</Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card style={{ minWidth: '18rem', marginBottom: 30 }}>
                                    {/* <Card.Header className="dashboard-cartao"><Row><Col lg={8} style={{display: 'flex', alignItems: 'center'}}>Cadastro de Produtos</Col><Col lg={2}><Form.Control size="sm" type="text" placeholder="Filtrar por Descrição" /></Col><Col lg={2}><Form.Control size="sm" type="text" placeholder="Filtrar por Departamento" /></Col></Row></Card.Header> */}
                                    <Card.Header className="dashboard-cartao">Propostas Comerciais</Card.Header>
                                    <Card.Body>
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                columns={colunas}
                                                data={propostas}
                                                onRowClicked={(row, index) => {
                                                    setModoEdicao(true)
                                                    setPropostaSelecionada(row)
                                                    setItemAtual({ item: '', valor: '', desconto: '0' })
                                                    GetItensPropostas(row.prop_id)
                                                    setModalProposta(true)
                                                }}
                                                striped={true}
                                                highlightOnHover={true}
                                                responsive={true}
                                                pointerOnHover={true}
                                                noDataComponent={"Nenhum Registro Encontrado =/"}
                                                pagination={true}
                                                paginationComponentOptions={paginationComponentOptions}
                                            />
                                        </DataTableExtensions>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

            <Modal
                show={modalProposta}
                onHide={() => { setModalProposta(false) }}
                backdrop="static"
                keyboard={false}
                dialogClassName={"modal-50"}
                centered
            >

                <Modal.Body>

                    <Tabs
                        defaultActiveKey="geral"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                    >
                        <Tab eventKey="geral" title="Geral">
                            <Row>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Cliente</Form.Label>
                                        <Form.Control style={{ textTransform: "capitalize" }} size="sm" type="text" onChange={(e) => { setPropostaSelecionada({ ...propostaSelecionada, prop_cliente: e.target.value }) }} value={propostaSelecionada?.prop_cliente} />
                                    </Form.Group>
                                </Col>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Contato</Form.Label>
                                        <Form.Control style={{ textTransform: "capitalize" }} size="sm" type="text" onChange={(e) => { setPropostaSelecionada({ ...propostaSelecionada, prop_contato: e.target.value }) }} value={propostaSelecionada?.prop_contato} />
                                    </Form.Group>
                                </Col>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Plano</Form.Label>
                                        <Form.Select size="sm" onChange={(e) => { setPropostaSelecionada({ ...propostaSelecionada, prop_plano: e.target.value }) }} value={propostaSelecionada?.prop_plano}>
                                            <option>Selecione</option>
                                            <option value="BASICO">Básico</option>
                                            <option value="PRO">Pró</option>
                                            <option value="COMPLETO">Completo</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>E-mail</Form.Label>
                                        <Form.Control style={{ textTransform: "lowercase" }} size="sm" type="email" onChange={(e) => { setPropostaSelecionada({ ...propostaSelecionada, prop_email: e.target.value }) }} value={propostaSelecionada?.prop_email} />
                                    </Form.Group>
                                </Col>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>WhatsApp</Form.Label>
                                        <Form.Control style={{ textTransform: "capitalize" }} size="sm" type="text" onChange={(e) => { setPropostaSelecionada({ ...propostaSelecionada, prop_whatsapp: e.target.value }) }} value={propostaSelecionada.prop_whatsapp ? formatToPhone(propostaSelecionada?.prop_whatsapp) : null} />
                                    </Form.Group>
                                </Col>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Status</Form.Label>
                                        <Form.Select size="sm" onChange={(e) => { setPropostaSelecionada({ ...propostaSelecionada, prop_status: e.target.value }) }} value={propostaSelecionada?.prop_status}>
                                            <option>Selecione</option>
                                            <option value="PENDENTE_ENVIO">Pendente Envio</option>
                                            <option value="ENVIADA">Enviada</option>
                                            <option value="APROVADA">Aprovada</option>
                                            {/* <option value="REAL">Lucro Real</option>
                                    <option value="PRESUMIDO">Lucro Presumido</option> */}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Qtde de Times</Form.Label>
                                        <Form.Control size="sm" type="number" onChange={(e) => { setPropostaSelecionada({ ...propostaSelecionada, prop_qtde_times: e.target.value }) }} value={propostaSelecionada?.prop_qtde_times} />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Qtde de Membros por Time</Form.Label>
                                        <Form.Control size="sm" type="number" onChange={(e) => { setPropostaSelecionada({ ...propostaSelecionada, prop_qtde_membros: e.target.value }) }} value={propostaSelecionada?.prop_qtde_membros} />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Tab>
                        <Tab eventKey="condicoes" title="Condições" disabled={!modoEdicao} >
                            <Row>
                                <Col lg={3}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Descrição do Item</Form.Label>
                                        <Form.Control style={{ textTransform: "capitalize" }} size="sm" type="text" onChange={(e) => { setItemAtual({ ...itemAtual, item: e.target.value }) }} value={itemAtual?.item} />
                                    </Form.Group>
                                </Col>
                                <Col lg={2}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Periodicidade</Form.Label>
                                        <Form.Select size="sm" onChange={(e) => { setItemAtual({ ...itemAtual, item_periodicidade: e.target.value }) }} value={itemAtual?.item_periodicidade}>
                                            <option>Selecione</option>
                                            <option value="MENSAL">MENSAL</option>
                                            <option value="TRIMESTRAL">TRIMESTRAL</option>
                                            <option value="SEMESTRAL">SEMESTRAL</option>
                                            <option value="ANUAL">ANUAL</option>
                                        </Form.Select>
                                    </Form.Group>

                                </Col>
                                <Col lg={2}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Valor</Form.Label>
                                        <Form.Control style={{ textTransform: "capitalize" }} size="sm" type="number" onChange={(e) => { setItemAtual({ ...itemAtual, valor: e.target.value }) }} value={itemAtual?.valor} />
                                    </Form.Group>
                                </Col>
                                <Col lg={2}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Desconto</Form.Label>
                                        <Form.Control style={{ textTransform: "capitalize" }} size="sm" type="number" onChange={(e) => { setItemAtual({ ...itemAtual, desconto: e.target.value }) }} value={itemAtual?.desconto} />
                                    </Form.Group>
                                </Col>
                                <Col lg={2}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Valor Final</Form.Label>
                                        <Form.Control style={{ textTransform: "capitalize" }} size="sm" type="number" value={Number(itemAtual?.valor) - Number(itemAtual?.desconto)} disabled />
                                    </Form.Group>
                                </Col>
                                <Col lg={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Button variant="success" onClick={() => {
                                        if (itemAtual?.item && itemAtual?.valor && itemAtual?.desconto) {
                                            IncluirItemProposta()
                                        } else {
                                            alert('Campos Inválidos')
                                        }
                                    }}>Incluir</Button>
                                </Col>
                            </Row>
                            <Row>
                                <DataTable
                                    columns={colunasItens}
                                    data={itensPropostas}
                                    striped={true}
                                    highlightOnHover={true}
                                    responsive={true}
                                    pointerOnHover={true}
                                    noDataComponent={"Nenhum Registro Encontrado =/"}
                                    pagination={true}
                                    paginationComponentOptions={paginationComponentOptions}
                                />
                            </Row>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light"
                        onClick={() => { setModalProposta(false) }}
                    >
                        Fechar
                    </Button>
                    {modoEdicao &&
                        <Button variant="danger" onClick={() => {

                            ExcluirProposta()
                            setModalProposta(false)

                        }}>Excluir</Button>
                    }
                    {modoEdicao &&
                        <Button variant="dark" onClick={() => {

                            // alert(limpaCNPJ(propostaSelecionada.loja_cnpj))
                            AtualizarProposta()
                            setModalProposta(false)

                        }}>Salvar</Button>
                    }
                    {!modoEdicao &&
                        <Button variant="dark" onClick={() => {

                            // alert(limpaCNPJ(propostaSelecionada.loja_cnpj))
                            IncluirProposta()
                            setModalProposta(false)

                        }}>Cadastrar</Button>
                    }
                    {modoEdicao &&
                        <Button variant="primary" onClick={() => {

                            let encoded = base64_encode(propostaSelecionada?.prop_id);

                            window.open('https://proposta.gestaodevalidades.com.br/' + encoded, '_blank').focus();

                        }}>Abrir</Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default TelaPropostas